module.exports = __webpack_public_path__ + "static/media/7-concealers-hue.28bb47b2.jpg";